<template>
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!loading">{{ title }}</h5>
                    <button type="button" class="close" aria-label="Close" @click="hideModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-break c-preformat" v-if="!loading" v-html="body"></div>
                <loader v-if="loading"></loader>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from './Loader.vue'
export default {
    components: {
        Loader,
    },
    props: {
        loading: Boolean,
        title: String,
        body: String,
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: this.value,
        }
    },
    mounted() {
        $(this.$refs.modal).modal({
            show: this.show
        })
        .on('shown.bs.modal', () => this.show = true)
        .on('hidden.bs.modal', () => this.show = false)
    },
    watch: {
        value(value) {
            value ? this.showModal() : this.hideModal()
        },
        show(show) {
            (show != this.value) && this.$emit('input', show)
        }
    },
    methods: {
        showModal() {
            $(this.$refs.modal).modal('show')
        },
        hideModal() {
            $(this.$refs.modal).modal('hide')
        }
    }
}
</script>